import { ContactConfig } from '../../contact.types';

export default {
  links: [
    {
      label: 'Check out HARP Help for more info on HARP',
      routerLink: '/help',
    },
  ],
  customContactDetails: `
    <h3 class="harp-title mb-4">Here's how to contact us</h3>

    <div class="row">
      <div class="col-3">
        <p class="mb-4">Take a short survey to give us feedback on HARP</p>

        <a class="mt-4" href="https://5huhhgk4.optimalworkshop.com/questions/48cqjh18" target="_blank">Give us feedback</a>
      </div>

      <div class="col-3">
        <p class="mb-4">Want to participate in HARP user feedback sessions? Contact us at:</p>

        <a href="mailto:HARPUserResearch@cms.hhs.gov">HARPUserResearch@cms.hhs.gov</a>
      </div>
    </div>

  `,
} as ContactConfig;
